import { builder } from '../../../../../../../common/js/configs';
import { commonCreativeConfig } from '../../common-creative-config';

export const formatConfigUnmarshaller = {
  creative: builder.holder({
    url: commonCreativeConfig.url,
    creativeRatio: commonCreativeConfig.creativeRatio,
    objectFit: builder.string('creative_object_fit', {
      possibleValues: [
        {
          name: 'Cover',
          value: 'cover'
        },
        {
          name: 'Contain',
          value: 'contain'
        }
      ],
      defaultValue: 'contain'
    }),
    objectFitStrategy: builder.holder({
      useStrategy: builder.boolean('object_fit_use_strategy', {
        defaultValue: false
      }),
      landscape: builder.string('object_fit_strategy_landscape', {
        possibleValues: [
          {
            name: 'Cover',
            value: 'cover'
          },
          {
            name: 'Contain',
            value: 'contain'
          }
        ],
        defaultValue: 'contain'
      }),
      portrait: builder.string('object_fit_strategy_portrait', {
        possibleValues: [
          {
            name: 'Cover',
            value: 'cover'
          },
          {
            name: 'Contain',
            value: 'contain'
          }
        ],
        defaultValue: 'cover'
      })
    })
  })
};
